import { DATE_FORMAT } from "helpers/common";
import React from "react";
import { Tooltip } from "react-tooltip";

const STATUS = {
  active: "Active",
  completed: "Completed",
  deleted: "Deleted",
};

const Columns = ({ handleEditHandler }) => [
  {
    dataField: "JackpotID",
    text: "JackpotID",
    formatter: (_, row) => (
      <span className="text-capitalize">
        <Tooltip id="my-tooltip" />

        {row?.jackpotID}
        {row.isRoundMultiplier && (
          <button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Played by Round Multilplier"
            className="border-0 p-0 bg-transparent"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.288 20.713C11.096 20.521 11 20.2833 11 20V14.4L7.05 18.375C6.85 18.575 6.61267 18.675 6.338 18.675C6.06334 18.675 5.82567 18.575 5.625 18.375C5.42434 18.175 5.32434 17.9377 5.325 17.663C5.32567 17.3883 5.42567 17.1507 5.625 16.95L9.6 13H4C3.71667 13 3.47934 12.904 3.288 12.712C3.09667 12.52 3.00067 12.2827 3 12C2.99934 11.7173 3.09534 11.48 3.288 11.288C3.48067 11.096 3.718 11 4 11H9.6L5.625 7.05C5.425 6.85 5.325 6.61267 5.325 6.338C5.325 6.06334 5.425 5.82567 5.625 5.625C5.825 5.42434 6.06267 5.32434 6.338 5.325C6.61334 5.32567 6.85067 5.42567 7.05 5.625L11 9.6V4C11 3.71667 11.096 3.47934 11.288 3.288C11.48 3.09667 11.7173 3.00067 12 3C12.2827 2.99934 12.5203 3.09534 12.713 3.288C12.9057 3.48067 13.0013 3.718 13 4V9.6L16.95 5.625C17.15 5.425 17.3877 5.325 17.663 5.325C17.9383 5.325 18.1757 5.425 18.375 5.625C18.5743 5.825 18.6743 6.06267 18.675 6.338C18.6757 6.61334 18.5757 6.85067 18.375 7.05L14.4 11H20C20.2833 11 20.521 11.096 20.713 11.288C20.905 11.48 21.0007 11.7173 21 12C20.9993 12.2827 20.9033 12.5203 20.712 12.713C20.5207 12.9057 20.2833 13.0013 20 13H14.4L18.375 16.95C18.575 17.15 18.675 17.3877 18.675 17.663C18.675 17.9383 18.575 18.1757 18.375 18.375C18.175 18.5743 17.9377 18.6743 17.663 18.675C17.3883 18.6757 17.1507 18.5757 16.95 18.375L13 14.4V20C13 20.2833 12.904 20.521 12.712 20.713C12.52 20.905 12.2827 21.0007 12 21C11.7173 20.9993 11.48 20.9043 11.288 20.713Z"
                fill="#7B6EE1"
              ></path>
            </svg>
          </button>
        )}
      </span>
    ),
  },
  {
    dataField: "ID",
    text: "ID",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.userDetails?.username}</span>
    ),
  },
  {
    dataField: "Username",
    text: "Username",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row?.userDetails?.telegram_username
          ? row?.userDetails?.telegram_username
          : row?.userDetails?.first_name}
      </span>
    ),
  },

  {
    dataField: "wonEnergy",
    text: "Won Energy",
    formatter: (_, row) => <span className="text">{row?.wonEnergy}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return <span>&nbsp;&nbsp;▲▼</span>; // Default (no sort)
      else if (order === "asc")
        return <span>&nbsp;&nbsp;▲</span>; // Ascending
      else if (order === "desc") return <span>&nbsp;&nbsp;▼</span>; // Descending
      return null;
    },
  },

  {
    dataField: "wonBtnc",
    text: "Won BTNC",
    formatter: (_, row) => <span className="text">{row?.wonBtnc}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return <span>&nbsp;&nbsp;▲▼</span>; // Default (no sort)
      else if (order === "asc")
        return <span>&nbsp;&nbsp;▲</span>; // Ascending
      else if (order === "desc") return <span>&nbsp;&nbsp;▼</span>; // Descending
      return null;
    },
  },
  {
    dataField: "wonAmount",
    text: "Won Amount",
    formatter: (_, row) => <span className="text">{row?.wonAmount}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return <span>&nbsp;&nbsp;▲▼</span>; // Default (no sort)
      else if (order === "asc")
        return <span>&nbsp;&nbsp;▲</span>; // Ascending
      else if (order === "desc") return <span>&nbsp;&nbsp;▼</span>; // Descending
      return null;
    },
  },
  {
    dataField: "status",
    text: "status",
    formatter: (_, row) => (
      <span className="text-capitalize">{STATUS[row?.status]}</span>
    ),
  },
  {
    text: "completedAt",
    dataField: "completed At",
    formatter: (_, row) => row.completedAt && DATE_FORMAT(row.completedAt),
  },
  {
    text: "Action",
    dataField: "status",
    formatter: (_, row) => (
      <button
        className="fas fa-eye"
        style={{
          fontSize: "16px",
          backgroundColor: "#fff",
          border: "none",
        }}
        title="Edit"
        onClick={() => handleEditHandler(row)}
      ></button>
    ),
  },
];
export default Columns;
